import React, { useId } from 'react';

// A: Arun. Cube edges: cloud-native building blocks. Orbit: connected platforms.
export function ArunkubeSymbol({ className = '' }) {
  const id = useId().replace(/:/g, '');
  return <svg className={`arunkube-symbol ${className}`} viewBox="0 0 160 160" fill="none" aria-hidden="true">
    <defs><linearGradient id={`arunkube-${id}`} x1="30" y1="30" x2="130" y2="135" gradientUnits="userSpaceOnUse"><stop stopColor="#8ee8ff" /><stop offset=".55" stopColor="#8faaff" /><stop offset="1" stopColor="#c69aff" /></linearGradient></defs>
    <path className="brand-cube" d="M80 19L132 49V109L80 139L28 109V49L80 19Z M28 49L80 79L132 49 M80 79V139" stroke={`url(#arunkube-${id})`} strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M46 114L77 47L87 47L119 114H103L82 67L61 114Z" fill="var(--logo-core, #f3f6ff)" />
    <path d="M66 95H98L104 108H60Z" fill={`url(#arunkube-${id})`} />
    <ellipse cx="80" cy="80" rx="75" ry="31" transform="rotate(-32 80 80)" stroke={`url(#arunkube-${id})`} strokeWidth="1.6" strokeDasharray="120 12 42 10" opacity=".85" />
    <g className="brand-satellite"><circle cx="143" cy="45" r="4" fill="#ffd099" /><circle cx="143" cy="45" r="8" stroke="#ffd099" strokeOpacity=".25" /></g>
  </svg>;
}

export default function ArunkubeLogo() {
  return <span className="arunkube-lockup"><ArunkubeSymbol /><span className="arunkube-wordmark">Arun <span>Bharathwaj</span></span></span>;
}
